import { createContext } from "react"

const PageTitleContext = createContext({
    pageTitle: "UNISONO Alumni Club",
    setPageTitle: (title: string) => {}
})

export default PageTitleContext